export default __webpack_public_path__ + "static/media/01.15.25 Minutes spcl mtg .2acddfa7.pdf";